import { tlwTwMerge } from '@trg/utils';
import { Icon, Link, type LinkProps } from '@trg/tlw-ui-component';
import type { SubCategory } from '../../api';

export type SubCategoryLinkProps = Omit<
  LinkProps,
  'href' | 'title' | 'children'
> & {
  category: SubCategory;
  showArrow?: boolean;
  isActive?: boolean;
};

export function SubCategoryLink({
  category,
  showArrow,
  isActive,
  className,
  ...props
}: SubCategoryLinkProps) {
  return (
    <Link
      className={tlwTwMerge(
        'tlw-txt-zh-head-6 tlw-text-txt-700 tlw-px-5 tlw-py-2 tlw-flex tlw-justify-between tlw-items-center tlw-gap-1 tlw-duration-300 hover:tlw-text-txt-white hover:tlw-bg-pr',
        'lg:tlw-txt-zh-head-7 lg:tlw-pl-3 lg:tlw-pr-2 lg:tlw-rounded-lg lg:hover:tlw-text-txt-core lg:hover:tlw-bg-white',
        isActive && [
          'tlw-text-txt-white tlw-bg-pr',
          'lg:tlw-text-txt-core lg:tlw-bg-white',
        ],
        className
      )}
      href={category.link}
      title={category.title}
      {...props}
    >
      <span className="tlw-line-clamp-2 lg:tlw-line-clamp-1">
        {category.title}
      </span>

      {showArrow && (
        <Icon
          className="tlw-hidden lg:tlw-block tlw-shrink-0"
          name="Right"
          size={16}
        />
      )}
    </Link>
  );
}
